/* First option in SELECT tag don't need to be BLANK */
$('.form-control').on('focus load blur change', function (e) {

    var $currEl = $(this);
    var x = $("option:first", $currEl).text();
    x = (x != null ? x.length : 0);
    // console.log(x);
    x = (x * 8 / 1.3) + 12;

    var maxLength = Math.max.apply(null, $currEl.map(function () {
        return $(this).width();
    }).get());

    x = maxLength > x ? x : maxLength - 20;


    if ($currEl.is('select')) {
        if ($currEl.val() === $("option:first", $currEl).val()) {
            $('.control-label', $currEl.parent()).animate({
                opacity: 0
            }, 240);
            $currEl.parent().removeClass('focused');
            $('.error', $currEl.parent()).text('*');
            $('.error', $currEl.parent()).css('margin-left', x + 'px');
        } else {
            $('.control-label', $currEl.parent()).css({
                opacity: 1
            });
            $('.error', $currEl.parent()).remove('*');
            $currEl.parents('.form-group').toggleClass('focused', ((e.type === 'focus' || this.value.length > 0) && ($currEl.val() !== $("option:first", $currEl).val())));
        }
    } else {
        $('.error', $currEl.parent()).text('*');
        $('.error', $currEl.parent()).css('margin-left', x + 'px');
        $currEl.parents('.form-group').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
    }
}).trigger('blur');


